// --- imports ---
import React, { Component } from "react";
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { BASE_URL, toastError } from "../../utils/constants";
import { Modal } from "react-bootstrap";
import { getCmsContent_action } from "../../actions/cms_action/cmsAction";

import "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";

console.log("[CMS/Index Module] loaded -> OK");

class CmsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            currentIndex: 0,
            cmsSectionData: [],
            MenuID: "",
            MenuUrl: "",
            cmsMenuData: [],
            cmsFooterData: [],
            cmsBannerData: [],
            isBannerOpen: false,
            cmsSubheaderData: [],
            downloadUrl: "",
            isHomePage: false,

            // ✅ PDF Viewer State
            pdfModalOpen: false,
            pdfFileUrl: null,
            numPages: 0
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        if (this.props.location.pathname === "/") {
            this.setState(
                { MenuUrl: "home", MenuID: 1, cmsMenuData: [], isHomePage: true },
                () => this.getCmsContent(1, "home")
            );
            return;
        }

        const path = this.props.location.pathname;
        const parts = path.split("&");
        if (parts.length === 2) {
            this.setState(
                { MenuUrl: parts[0], MenuID: parts[1], cmsMenuData: [] },
                () => this.getCmsContent(parts[1], parts[0])
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);

            const path = this.props.location.pathname;
            const parts = path.split("&");

            if (path === "/") {
                this.setState(
                    { MenuUrl: "home", MenuID: 1, cmsMenuData: [], isHomePage: true },
                    () => this.getCmsContent(1, "home")
                );
            } else if (parts.length === 2) {
                if (parts[1] === "1" && !this.state.isHomePage) {
                    window.location.href = "/";
                    return;
                }
                this.setState(
                    { MenuUrl: parts[0], MenuID: parts[1], cmsMenuData: [], isHomePage: false },
                    () => this.getCmsContent(parts[1], parts[0])
                );
            }
        }
    }

    async getCmsContent(MenuID, MenuUrl) {
        const formattedUrl = MenuUrl?.startsWith("/") ? MenuUrl.substring(1) : MenuUrl;
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID || 1, formattedUrl || "home");

            if (data.error !== 1) {
                this.setState(
                    {
                        isLoading: false,
                        cmsSectionData: data?.data[0] || [],
                        cmsMenuData: data?.data[1] || [],
                        cmsFooterData: data?.data[2]?.[0] || [],
                        cmsUploadData: data?.data[3] || [],
                        cmsSubheaderData: data?.data[4] || [],
                        cmsBannerData: data?.data[5]?.[0] || [],
                        isBannerOpen: data?.data?.[5]?.[0]?.isActive && this.state.isHomePage
                    },
                    () => setTimeout(() => this.runDynamicScripts(), 600)
                );
            } else {
                toastError(data.msg);
                this.setState({ isLoading: false });
                if (data.msg === "Page not found.") this.props.navigate("/");
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    runDynamicScripts() {
        //STEP 0 — Convert <a> → <span> BUT *SAFE*
        document.querySelectorAll("a[href]").forEach(a => {
            const href = a.getAttribute("href") || "";
            if (href.startsWith("/")) return;

            if (href.startsWith("#/")) return;

            if (/^https?:\/\//i.test(href)) return;

            if (a.classList.contains("visitor_header_footer_click")) return;

            const span = document.createElement("span");

            for (const attr of a.attributes) {
                if (attr.name !== "href") span.setAttribute(attr.name, attr.value);
            }

            span.setAttribute("data-href", href);
            span.innerHTML = a.innerHTML;
            span.style.cursor = "pointer";
            span.classList.add("no-link-preview");

            a.parentNode.replaceChild(span, a);
        });

        //STEP 1 — Helper: slideToggle
        const slideToggle = (el, duration = 300) => {
            if (window.getComputedStyle(el).display === "none") {
                el.style.display = "block";
                const h = el.scrollHeight;
                el.style.overflow = "hidden";
                el.style.maxHeight = 0;
                el.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => (el.style.maxHeight = h + "px"), 10);
                setTimeout(() => {
                    el.style.removeProperty("max-height");
                    el.style.removeProperty("overflow");
                    el.style.removeProperty("transition");
                }, duration);
            } else {
                el.style.overflow = "hidden";
                el.style.maxHeight = el.scrollHeight + "px";
                el.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => (el.style.maxHeight = 0), 10);
                setTimeout(() => {
                    el.style.display = "none";
                    el.style.removeProperty("max-height");
                    el.style.removeProperty("overflow");
                    el.style.removeProperty("transition");
                }, duration);
            }
        };

        //STEP 2 — Preloader
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "0";
            setTimeout(() => (preloader.style.display = "none"), 500);
        }

        //STEP 3 — WOW & AOS
        if (typeof window.WOW === "function") new window.WOW()?.init();
        if (typeof window.AOS === "object") window.AOS?.init({ duration: 1000, mirror: true });

        //STEP 4 — Mobile Menu
        const mobileMenuContainer = document.querySelector(".tgmobile__menu");

        if (mobileMenuContainer) {
            document.querySelectorAll(".tgmenu__wrap .navigation li.menu-item-has-children").forEach(li => {
                if (!li.querySelector(".dropdown-btn")) {
                    li.insertAdjacentHTML("beforeend", '<div class="dropdown-btn"><span class="plus-line"></span></div>');
                }
            });

            const mobileMenuOuter = document.querySelector(".tgmobile__menu-box .tgmobile__menu-outer");
            if (mobileMenuOuter && !mobileMenuOuter.innerHTML) {
                const mainMenu = document.querySelector(".tgmenu__wrap .tgmenu__main-menu")?.innerHTML;
                if (mainMenu) mobileMenuOuter.innerHTML = mainMenu;
            }

            document.querySelectorAll(".tgmobile__menu li.menu-item-has-children .dropdown-btn").forEach(btn => {
                btn.addEventListener("click", function () {
                    this.classList.toggle("open");
                    const submenu = this.previousElementSibling;
                    if (submenu && submenu.tagName === "UL") slideToggle(submenu, 300);
                });
            });

            document.querySelector(".mobile-nav-toggler")?.addEventListener("click", () => {
                document.body.classList.add("mobile-menu-visible");
            });

            document.querySelectorAll(".tgmobile__menu-backdrop, .tgmobile__menu .close-btn").forEach(el =>
                el.addEventListener("click", () => document.body.classList.remove("mobile-menu-visible"))
            );
        }

        // STEP 5 — Sticky Header
        window.addEventListener("scroll", () => {
            const y = window.scrollY;
            const sticky = document.getElementById("sticky-header");
            const scrollBtn = document.querySelector(".scroll-to-target");
            const headerHeight = document.getElementById("header-fixed-height");

            if (y < 245) {
                sticky?.classList.remove("sticky-menu");
                scrollBtn?.classList.remove("open");
                headerHeight?.classList.remove("active-height");
            } else {
                sticky?.classList.add("sticky-menu");
                scrollBtn?.classList.add("open");
                headerHeight?.classList.add("active-height");
            }
        });

        document.querySelector(".scroll-to-target")?.addEventListener("click", function () {
            const t = document.querySelector(this.getAttribute("data-target"));
            if (t) window.scrollTo({ top: t.offsetTop, behavior: "smooth" });
        });

        //STEP 6 — Backgrounds
        document.querySelectorAll("[data-background]").forEach(el => {
            el.style.backgroundImage = `url(${el.getAttribute("data-background")})`;
        });
        document.querySelectorAll("[data-bg-color]").forEach(el => {
            el.style.backgroundColor = el.getAttribute("data-bg-color");
        });

        //STEP 7 — Search Popup
        document.querySelector(".search-open-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.add("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.add("search-popup-overlay-open");
        });

        document.querySelector(".search-close-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.remove("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.remove("search-popup-overlay-open");
        });

        //STEP 8 — Offcanvas Menu
        document.querySelector(".menu-tigger")?.addEventListener("click", e => {
            e.preventDefault();
            document.querySelector(".offCanvas__info")?.classList.add("active");
            document.querySelector(".offCanvas__overly")?.classList.add("active");
        });

        document.querySelectorAll(".menu-close, .offCanvas__overly").forEach(el => {
            el.addEventListener("click", () => {
                document.querySelector(".offCanvas__info")?.classList.remove("active");
                document.querySelector(".offCanvas__overly")?.classList.remove("active");
                document.querySelector(".offCanvas__info1")?.classList.remove("active");
            });
        });

        //STEP 9 — Swiper
        if (window.Swiper) {
            const initSwiper = (selector, options) => {
                const el = document.querySelector(selector);
                if (!el) return;
                if (el.swiper) return; // Prevent double-initialization
                try {
                    el.swiper = new window.Swiper(selector, options);
                } catch (err) {
                    console.error("Swiper init error on", selector, err);
                }
            };

            initSwiper('.slider-active', {
                spaceBetween: 0,
                effect: "fade",
                loop: true,
                autoplay: { delay: 6000 }
            });

            initSwiper('.slider-active-two', {
                spaceBetween: 0,
                effect: "fade",
                navigation: {
                    nextEl: ".slider-button-next",
                    prevEl: ".slider-button-prev"
                }
            });

            initSwiper('.slider-active-three', {
                spaceBetween: 0,
                effect: "fade",
                loop: true,
                autoplay: { delay: 6000 }
            });

            initSwiper('.project_active', {
                slidesPerView: 3,
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: ".project-button-next",
                    prevEl: ".project-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });

            initSwiper('.brand-active', {
                slidesPerView: 5,
                spaceBetween: 24,
                loop: true,
                breakpoints: {
                    0: { slidesPerView: 2 },
                    576: { slidesPerView: 3 },
                    768: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 5 }
                }
            });

            initSwiper('.testimonial__active', {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: true,
                autoplay: { delay: 6000 },
                navigation: {
                    nextEl: ".testimonial-button-next",
                    prevEl: ".testimonial-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 }
                }
            });

            initSwiper('.AwardSwiper', {
                slidesPerView: 3,
                spaceBetween: 24,
                loop: true,
                autoplay: { delay: 6000 },
                navigation: {
                    nextEl: ".testimonial-button-next",
                    prevEl: ".testimonial-button-prev"
                },
                breakpoints: {
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 }
                }
            });
        }


        //ISOTOPE (FINAL WORKING VERSION)
        if (window.Isotope && window.imagesLoaded) {
            const grid = document.querySelector('.project-active-two');
            if (grid) {
                window.imagesLoaded(grid, () => {
                    const iso = new window.Isotope(grid, {
                        itemSelector: '.grid-item',
                        percentPosition: true,
                        masonry: { columnWidth: '.grid-item' }
                    });

                    document.querySelectorAll('.project__menu-nav button').forEach(btn => {
                        btn.addEventListener('click', function (e) {
                            e.preventDefault();

                            const filterValue = this.getAttribute('data-filter');
                            iso.arrange({ filter: filterValue });

                            document.querySelector('.project__menu-nav button.active')?.classList.remove('active');
                            this.classList.add('active');
                        });
                    });
                });
            }
        }

        //STEP 11 — FULL COUNTDOWN SYSTEM (Your version)
        const setupCountdown = (config) => {
            const targetDate = new Date(config.date);
            let interval = null;

            const update = () => {
                const now = new Date();
                const remaining = targetDate - now;

                if (remaining <= 0) {
                    if (interval) clearInterval(interval);
                    if (config.days) config.days.textContent = "00";
                    if (config.hours) config.hours.textContent = "00";
                    if (config.minutes) config.minutes.textContent = "00";
                    if (config.seconds) config.seconds.textContent = "00";
                    return;
                }

                const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                if (config.days) config.days.textContent = days.toString().padStart(2, "0");
                if (config.hours) config.hours.textContent = hours.toString().padStart(2, "0");
                if (config.minutes) config.minutes.textContent = minutes.toString().padStart(2, "0");
                if (config.seconds) config.seconds.textContent = seconds.toString().padStart(2, "0");
            };

            interval = setInterval(update, 1000);
            update();

            // trigger
            document.querySelectorAll(config.triggerSelector).forEach(trigger => {
                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (new Date() >= targetDate) {
                        window.open(config.redirectUrl, "_blank");
                    } else {
                        document.getElementById(config.modalId)?.classList.add("active");
                    }
                });
            });

            document.getElementById(config.closeId)?.addEventListener("click", () => {
                document.getElementById(config.modalId)?.classList.remove("active");
            });
        };

        // Your 3 countdowns
        setupCountdown({
            date: "2025-02-21T12:00:00",
            triggerSelector: ".register_click, .booking_click",
            modalId: "timer_Modal1",
            closeId: "close_timer_Modal1",
            redirectUrl: "https://india-itme.com/#/ITME2026",
            days: document.querySelector(".days1 .number1"),
            hours: document.querySelector(".hours1 .number1"),
            minutes: document.querySelector(".minutes1 .number1"),
            seconds: document.querySelector(".seconds1 .number1"),
        });

        setupCountdown({
            date: "2025-12-01T12:00:00",
            triggerSelector: ".visitor_header_footer_click",  // exception link
            modalId: "timer_Modal",
            closeId: "close_timer_Modal",
            redirectUrl: "https://india-itme.com/#/visitorregistration/ITME2026",
            days: document.querySelector(".days .number"),
            hours: document.querySelector(".hours .number"),
            minutes: document.querySelector(".minutes .number"),
            seconds: document.querySelector(".seconds .number"),
        });

        setupCountdown({
            date: "2025-02-21T12:00:00",
            triggerSelector: ".login_btn_click",
            modalId: "timer_Modal2",
            closeId: "close_timer_Modal2",
            redirectUrl: "https://india-itme.com/",
            days: document.querySelector(".days2 .number2"),
            hours: document.querySelector(".hours2 .number2"),
            minutes: document.querySelector(".minutes2 .number2"),
            seconds: document.querySelector(".seconds2 .number2"),
        });

        //STEP 12 — jQuery Plugins
        if (window.jQuery) {
            const $ = window.jQuery;

            if ($.fn.magnificPopup) {
                $(".popup-image").magnificPopup({ type: "image", gallery: { enabled: true } });
            }

            if ($.fn.marquee) {
                $(".marquee_mode").marquee({ speed: 20, gap: 35, direction: "left", duplicated: true, pauseOnHover: true });
            }
        }

        //STEP 13 — PDF / IMAGE Viewer
        document.querySelectorAll('span[data-href$=".pdf"]').forEach(span => {
            span.addEventListener("click", () =>
                this.openPdfViewer(span.getAttribute("data-href"), 1)
            );
        });

        document.querySelectorAll('span[data-href$=".jpg"], span[data-href$=".jpeg"], span[data-href$=".png"]').forEach(span => {
            span.addEventListener("click", () =>
                this.openPdfViewer(span.getAttribute("data-href"), 2)
            );
        });

        //STEP 14 — Internal Anchor Scroll (SAFE)
        document.querySelectorAll('span[data-href^="#"]').forEach(span => {
            const href = span.getAttribute("data-href");

            // ignore invalid ones
            if (href.startsWith("#/")) return;
            if (href.includes("/")) return;

            span.addEventListener("click", e => {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    const offset = document.getElementById("site-header")?.offsetHeight || 80;
                    const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            });
        });

        //STEP 15 — External URLs
        document.querySelectorAll('span[data-href^="http"]').forEach(span => {
            const href = span.getAttribute("data-href");
            if (!href.match(/\.(pdf|jpg|jpeg|png)$/i)) {
                span.addEventListener("click", () => window.open(href, "_blank"));
            }
        });

        // STEP 16 — CSS helper
        const style = document.createElement("style");
        style.textContent = `
        .no-link-preview { text-decoration: none; color: inherit; }
        .no-link-preview:hover { opacity: 0.85; }
    `;
        document.head.appendChild(style);
    }

    openPdfViewer = (url, urlType) => {
        console.log("%c[PDF] Loading →", "color:orange;font-weight:bold;", url);
        this.setState({ pdfModalOpen: true, pdfFileUrl: url, numPages: 0, urlType: urlType });
        if (urlType === 1) {
            setTimeout(() => {

                const container = document.getElementById("pdf-container");
                pdfjsLib.getDocument(url).promise.then(async (pdf) => {
                    for (let i = 1; i <= pdf.numPages; i++) {
                        const page = await pdf.getPage(i);
                        const viewport = page.getViewport({ scale: 1.5 });

                        const canvas = document.createElement("canvas");
                        const context = canvas.getContext("2d");

                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Responsive styling
                        canvas.style.width = "90%";
                        canvas.style.height = "auto";
                        canvas.style.display = "block";
                        canvas.style.margin = "20px auto";

                        container.appendChild(canvas);

                        await page.render({ canvasContext: context, viewport }).promise;
                    }
                });
            }, 500);
        }
        console.log("%c[PDF] Opening →", "color:blue;font-weight:bold;", url);
    };

    closePdfViewer = () => {
        this.setState({ pdfModalOpen: false, pdfFileUrl: null, numPages: 0 });
    };

    render() {
        const { isLoading, cmsSectionData, cmsMenuData, cmsFooterData, cmsBannerData, downloadUrl } = this.state;

        return (
            <>
                {isLoading && <Loader />}

                <main className="main-area fix">
                    <Header headerNavs={cmsMenuData} />

                    {cmsSectionData
                        ?.filter((s) => s.isPublish && s.isactive)
                        .sort((a, b) => a.SeqNo - b.SeqNo)
                        .map((section, index) => (
                            <section key={index} className="p-0">
                                <div dangerouslySetInnerHTML={{ __html: section.SectionContent }} />
                            </section>
                        ))}

                    {cmsBannerData?.isActive && cmsBannerData.isPublish && (
                        <Modal show={this.state.isBannerOpen} centered onHide={() => this.setState({ isBannerOpen: false })}>
                            <Modal.Body className="p-0 position-relative">
                                <button className="btn-close position-absolute top-0 end-0 m-2 bg-light"
                                    onClick={() => this.setState({ isBannerOpen: false })} />
                                <img width="100%" src={downloadUrl + cmsBannerData?.BannerFilepath} alt="banner" />
                            </Modal.Body>
                        </Modal>
                    )}
                </main>

                {/* ✅ PDF Viewer (react-pdf) */}
                {this.state.pdfModalOpen && (
                    <Modal show centered size="xl" backdrop="static" keyboard={false} onHide={this.closePdfViewer}>
                        <Modal.Body
                            style={{
                                padding: 20,
                                background: "#f9f9f9",
                                textAlign: "center",
                                userSelect: "none"
                            }}
                            onContextMenu={(e) => e.preventDefault()} // disable right-click
                        >
                            <button className="btn-close" onClick={this.closePdfViewer}
                                style={{ position: "absolute", top: 10, right: 10, zIndex: 99 }} />
                            {this.state.urlType === 1 ? (

                                <div
                                    id="pdf-container"
                                    style={{
                                        width: "99%",
                                        height: "80vh",       // keeps it scrollable inside card
                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                        background: '#f5f5f5'
                                    }}
                                ></div>
                            ) : this.state.urlType === 2 ? (
                                <img src={this.state.pdfFileUrl} style={{ pointerEvents: 'none' }} />
                            ) : <></>}
                        </Modal.Body>
                    </Modal>
                )}

                <Footer footerData={cmsFooterData} />
            </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action })(CmsIndex));